import React from "react";

const category = [
  { id: 1, name: "Legal", displayOn: ["en", "cn", "ru"] },
  { id: 2, name: "Construction", displayOn: ["en", "cn", "ru"] },
  { id: 3, name: "Rental Program", displayOn: ["en", "cn", "ru"] },
  { id: 4, name: "Property Management", displayOn: ["en", "cn", "ru"] },
  { id: 5, name: "Privileges", displayOn: ["en", "cn", "ru"] },
  // { id: 6, name: "Infrastructure & Common Areas", displayOn: ["en", "cn", "ru"] },
  { id: 7, name: "Financing", displayOn: ["en", "cn", "ru"] }
];

const faqs = [
  {
    categoryId: 1,
    question: "What types of ownership are available?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> As these villas are an integral part of the
            exclusive Dusit Laguna Resort Villas Phuket, land is offered on a
            leasehold basis only. Leases are registered with the Government
            (currently for a maximum period of 30 years as permitted by law) and
            are renewable. However, the buildings are sold as freehold.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Виллы являются частью эксклюзивного проекта
            Dusit Laguna Resort Villas Phuket, земля под строением
            предоставляется во владение на правах долгосрочной аренды.
            Необходима государственная регистрация арендных прав (в соответствии
            с действующим законодательством максимальный срок действия
            регистрации составляет 30 лет), с последующим продлением на новый
            срок. Однако здания продаются в полную собственность.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            由于这些别墅是普吉岛乐古浪都喜度假村别墅的组成部分，因此土地仅以租赁方式提供。租约须向政府登记(目前法律允许的最长期限为30
            年)，并可续期。然而，土地之上的建筑物以永久产权方式出售。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 1,
    question:
      "What are the costs associated with the lease / freehold registration?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> These are outlined below:
          </p>
          <ul>
            <li>
              <strong>Leasehold land title</strong>
              <p>
                Lease registration fees and stamp duty (currently 1.1% of the
                lease premium) is payable to the Land Department upon
                registration of the lease.
              </p>
            </li>
            <li>
              <strong>Freehold building title</strong>
              <p>
                Freehold registration fees (currently 2.0% of the appraisal
                price of building) is payable to the Land Department upon
                transfer and registration of title of the building. The
                appraisal price is calculated relative to the government’s tax
                assessment value which is generally well below market value.
                Other applicable taxes upon transfer and registration of
                freehold building title are:
              </p>
              <ul>
                <li className="white-circle">
                  <strong>Corporate Income Tax</strong>
                </li>
                <p>
                  (Currently 1.0% of the selling price or appraisal price,
                  whichever is higher)
                </p>
                <li className="white-circle">
                  <strong>Special Business Tax</strong>
                </li>
                <p>
                  (Currently 3.3% of the selling price or appraisal price,
                  whichever is higher)
                </p>
              </ul>
            </li>
          </ul>
          <p>
            The burden between the seller and the purchaser for the above costs
            will be specified in the Lease and/or Sale & Purchase Agreements.
          </p>
          <p>
            <small>
              <em>
                Note: Those certain applicable tax rates rely upon the relevant
                Thai tax laws at the date of issue of this Q&A. Changes in law
                or circumstances may occur after the issue date.
              </em>
            </small>
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Информация представлена ниже:
          </p>
          <ul>
            <li>
              <strong>Регистрация прав аренды на землю</strong>
              <p>
                При регистрации договора аренды в Земельном департаменте
                необходимо оплатить регистрационные сборы и пошлины (в настоящее
                время 1,1% от стоимости аренды земли).
              </p>
            </li>
            <li>
              <strong>Регистрация прав собственности</strong>
              <p>
                При регистрации договора аренды в Земельном департаменте
                необходимо оплатить регистрационные сборы и пошлины (в настоящее
                время 1,1% от стоимости аренды земли).
              </p>
              <ul>
                <li className="white-circle">
                  <strong>Корпоративный налог на прибыль</strong>
                </li>
                <p>
                  (в настоящее время 1,0% от продажной или оценочной стоимости,
                  используется самая высокая ставка)
                </p>
                <li className="white-circle">
                  <strong>Специальный предпринимательский налог</strong>
                </li>
                <p>
                  (в настоящее время 3,3% от продажной или оценочной стоимости,
                  используется самая высокая ставка)
                </p>
              </ul>
            </li>
          </ul>
          <p>
            Распределение вышеуказанных издержек между продавцом и покупателем
            определяется договорами аренды и/или купли-продажи.
          </p>
          <p>
            <small>
              <em>
                Примечание: Действующие налоговые ставки приведены в
                соответствии с соответствующим законодательством Таиланда на
                момент публикации настоящего документа, но могут быть изменены
                соответствующим властям Таиланда.
              </em>
            </small>
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong> 这些情况概述如下：
          </p>
          <ul>
            <li>
              <strong> 土地租赁权</strong>
              <p>
                租赁登记费及印花税(现为租赁价的1.1%)须在租赁登记后缴交土地管理部门。
              </p>
            </li>
            <li>
              <strong> 建筑永久产权</strong>
              <p>
                永久产权登记费（现为建筑物评估价格的2.0%）须在转让和登记建筑物产权时向土地管理部门缴付。评估价格是相对于政府的征税估值来计算的，一般远低于市场价值。转让及登记永久产权时适用的其他税项包括：
              </p>
              <ul>
                <li>
                  <strong>企业所得税</strong>
                </li>
                <p>(现为售价或评估价的1.0%，以较高者为准)</p>
                <li>
                  <strong>特定营业税</strong>
                </li>
                <p>(现为售价或评估价的3.3%，以较高者为准)</p>
              </ul>
            </li>
          </ul>
          <p>
            卖方和买方之间对上述费用的负担方式将在租赁和/或买卖协议中明确规定。
          </p>
          <p>
            <small>
              <em>
                注意：
                这些特定的适用税率取决于本常见问题发布日期的相关泰国税法。本问答内容发布后，法律或情况有可能变化可能。
              </em>
            </small>
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 1,
    question: "Is leasehold land transferable?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Leasehold land may be transferred subject to the
            terms and conditions of the agreements. Generally, an assignment fee
            is payable. In addition, the assignee must agree to be bound by the
            terms and conditions contained in the original lease agreement.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Передача прав при владении землей на правах
            аренды может осуществляться в соответствии с условиями договора
            аренды. Обычно за передачу прав взимается соответствующая плата.
            Кроме того, правопреемник должен подтвердить согласие с условиями
            первоначального договора аренды.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            租赁土地可根据双方协议的条款和条件进行转让。一般而言，需要支付转让费。此外，受让人必须同意受原始租赁协议所载条款和条件的约束。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 1,
    question: "Can leasehold be upgraded to freehold title?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> As these villas are an integral part of the
            exclusive Dusit Laguna Resort Villas Phuket, the option to purchase
            the land on a freehold basis is not available.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Так как данные виллы являются частью
            эксклюзивного проекта Dusit Laguna Resort Villas Phuket,
            приобретение прав на полное бессрочное владение земельным участком
            невозможно.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            由于这些别墅是普吉岛乐古浪都喜度假村别墅的组成部分，因此无法选择以永久产权方式购买土地。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 1,
    question: "Is leasehold land ownership secure?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Leasehold ownership is a common method of
            ownership for foreign buyers. Once the lease is registered at the
            Land Department, the right of use to the land will be vested with
            the lessee.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Владение недвижимостью на правах аренды — широко
            распространенная форма собственности для иностранных покупателей.
            Права арендатора официально признаются сразу же после регистрации
            договора аренды в Земельном департаменте.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            租赁所有权是外籍买受人获取所有权的常见方法。一旦租约在土地管理部门登记后，土地的使用权将赋予承租人。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 1,
    question: "Should I appoint a lawyer to review the agreements?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Our agreements have been used for a number of
            years and have been reviewed by major international law firms. We
            have our own in-house legal team which will assist to clarify any
            questions you may have concerning the agreements. However, should
            you wish to obtain specific advice regarding the structuring of your
            investment, we recommend you consult with a professional legal
            and/or financial adviser.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Наши договоры используются много лет и были
            проверены лучшими международными юридическими фирмами. У нас также
            есть своя команда юристов, готовая прояснить любые вопросы, которые
            могут возникнуть у вас в связи с договорами. Тем не менее, если вам
            понадобится консультация по каким-либо конкретным вопросам,
            касающимся планирования ваших инвестиций, мы рекомендуем обратиться
            к профессиональному юридическому и/или финансовому консультанту.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            我们的协议已经使用多年，并已经过各大国际律师事务所的审核。我们拥有自己的内部法律团队，将为您澄清与协议有关的任何问题。不过，如果您希望获得有关投资结构的具体建议，我们建议您咨询专业的法律和/或财务顾问。/或财务顾问。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 1,
    question:
      "When will be the lease / house transfer registration take place?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Within 90 days after full payments of the Rental
            and Purchase Price of the land and buildings have been made, we will
            notify the lessee / buyer of any required documents and fees which
            will be incurred upon registration.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> В течении 90 дней после оплаты полной стоимости
            и завершения объекта мы сообщим покупателю список необходимых
            документов и сборов, необходимых при регистрации.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong> 在土地及建筑物的租金及购买价款全额支付后90
            天内，我们会通知承租人/买受人在注册时需要提交的任何文件及需要支付的任何费用。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 2,
    question: "Types and number of properties for sale?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> There are twenty-two (22) luxury two and three
            bedroom pool villas planned at the Dusit Laguna Resort Phuket.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> В рамках проекта Dusit Laguna Resort Phuket
            планируется строительство двадцати двух (22) роскошных вилл с
            бассейнами, включающих в себя две или три спальни.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong> 普吉岛都喜乐古浪度假村计划有二十二（22）
            间豪华两卧室和三卧室泳池别墅。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 2,
    question: "How long does construction take?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Construction can only commence once the relevant
            government approvals are obtained and is estimated to take
            approximately 18-24 months to complete from the commencement date.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> В рамках проекта Dusit Laguna Resort Phuket
            планируется строительство двадцати двух (22) роскошных вилл с
            бассейнами, включающих в себя две или три спальни.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            只有在获得有关政府批准后才能开始施工，估计从施工日期起大约需要 18 至
            24 个月才能完成。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 2,
    question: "What is the warranty period offered?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> A one year warranty is offered on the building
            and equipment from the date of handover and completion of
            construction.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Предлагается гарантия на здания и оборудование
            сроком на один год с момента сдачи проекта и завершения
            строительства.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            从移交和施工完成之日起，对建筑物和设备提供为期一年的保修。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 2,
    question: "What is included in the property?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Fixed furnishings (wardrobes, kitchen cabinets
            and built-in appliances) and loose furniture (including amenities
            and artworks) is included.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Встроенная мебель (шкафы, кухонная мебель и
            встраиваемая техника) и движимая мебель (в том числе удобства и
            декор).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            固定家具（衣柜，橱柜和内嵌电器）和活动家具（含设施设备和艺术品）包括在内。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 2,
    question: "Is customization of the units allowed?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> As the villas will be managed as part of the
            resort, a standard configuration and furniture and amenities package
            is required.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Управление виллами осуществляется в рамках
            управления курортом, т. е. требуется стандартный набор мебели и
            удобств.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            由于别墅将作为度假村的一部分进行管理，因此需要采用标准配置以及家具和设施套装。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 3,
    question: "Is there a rental program available?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong>
            Yes, these luxury villas will be professionally and exclusively
            managed by Dusit Laguna Phuket offering a unique investment
            opportunity.
          </p>
          <p>
            In addition, owners shall be entitled to 60 days complimentary use
            of their villa (room only, does not include breakfast or personal
            expenses) per year (terms and conditions apply).
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong>
            Да, профессиональное эксклюзивное управление будет осуществляться
            отелем Dusit Laguna Phuket, что представляет собой уникальную
            инвестиционную возможность.
          </p>
          <p>
            Более того, владельцы получают право на 60 дней проживания (только
            проживание, завтрак или личные расходы не предусматриваются) на
            своей вилле ежегодно (согласно действующим условиям).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong> 是的，这些豪华别墅将由普吉岛乐古浪都喜酒店的专业人士独家管理，为您提供独特的投资机会。
          </p>
          <p>
            此外，业主享有权利可每年60
            天免费使用所购别墅（仅限住宿，不包括早餐或个人消费）（受条款和条件约束）。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 3,
    question: "How does the rental program work?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> The rental returns paid to owners will be
            calculated based upon a 33% share of net room revenue (the balance
            being retained by to cover operating expenses of the rental
            program). In addition, a reserve fund (3% of room revenue) will be
            deducted and held for future refurbishment costs. An example of how
            the return returns are determined is set out below:
          </p>
          <table>
            <thead>
              <tr>
                <td>Day Available</td>
                <td>365</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Days Sold</td>
                <td>250</td>
              </tr>
              <tr>
                <td>Occupancy %</td>
                <td>68%</td>
              </tr>
              <tr>
                <td>Average Daily Rate (Baht)</td>
                <td>20,000</td>
              </tr>
              <tr>
                <td>Net Room Revenue (Baht)</td>
                <td>5,000,000</td>
              </tr>
              <tr>
                <td>Revenue Share to Owner @ 33% (Baht)</td>
                <td>1,650,000</td>
              </tr>
              <tr>
                <td>Less Reserve Fund Contribution @ 3% of Revenue</td>
                <td>(150,000)</td>
              </tr>
              <tr>
                <td>Revenue Share to Owner – Before Withholding Tax</td>
                <td>1,500,000</td>
              </tr>
            </tbody>
          </table>
          <small>
            <em>
              Note: The operation of the rental program is at the discretion of
              the manager and may be subject to change. The above example is
              indicative only of how the rental returns will be determined and
              may not reflect the actual returns achieved.
            </em>
          </small>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Доход с аренды, получаемый собственником,
            составляет 33% от чистого дохода с аренды недвижимости (остаток
            причитается управляющей компании для покрытия эксплуатационных
            расходов, сопряженных с программой сдачи в аренду). Кроме того,
            резервный фонд (3 % от общего дохода) будет вычитаться в счет
            будущих ремонтных работ.
          </p>
          <br />
          <p>Пример расчета доходов приведен ниже:</p>
          <table>
            <thead>
              <tr>
                <td>Доступно дней</td>
                <td>365</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Продано дней</td>
                <td>250</td>
              </tr>
              <tr>
                <td>Продано дней</td>
                <td>68%</td>
              </tr>
              <tr>
                <td>Средняя стоимость в сутки (баты)</td>
                <td>20,000</td>
              </tr>
              <tr>
                <td>Чистый доход с недвижимости (баты)</td>
                <td>5,000,000</td>
              </tr>
              <tr>
                <td>Доля дохода, получаемая владельцем @ 33% (баты)</td>
                <td>1,650,000</td>
              </tr>
              <tr>
                <td>Отчисления в резервный фонд @ 3% с дохода</td>
                <td>(150,000)</td>
              </tr>
              <tr>
                <td>
                  Доля дохода, получаемая владельцем – до уплаты налогов (до
                  вычета налогов)
                </td>
                <td>1,500,000</td>
              </tr>
            </tbody>
          </table>
          <small>
            <em>
              Примечание: Программа аренды реализуется по усмотрению управляющей
              компании и может подвергаться изменениям. Пример выше приведен в
              иллюстративных целях для демонстрации того, как рассчитываются
              доходы от сдачи в аренду, и может не отражать реальную прибыль
            </em>
          </small>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            租赁回报为房间净收益33%（其余收入将被保留用于租赁计划的运营费用）。此外，将扣除预留资金（占房间收入的3%），以支付未来的翻新费用
          </p>
          <p>以下是如何确定收益回报的示例： </p>
          <table>
            <thead>
              <tr>
                <td>可用天数</td>
                <td>365</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>售出天数</td>
                <td>250</td>
              </tr>
              <tr>
                <td>入住率%</td>
                <td>68%</td>
              </tr>
              <tr>
                <td>平均每日房价（泰铢）</td>
                <td>20,000</td>
              </tr>
              <tr>
                <td>房间净收入（泰铢）</td>
                <td>5,000,000</td>
              </tr>
              <tr>
                <td>业主所得收益份额@ 33% (泰铢)</td>
                <td>1,650,000</td>
              </tr>
              <tr>
                <td>减去预留资金@ 收入的3%</td>
                <td>(150,000)</td>
              </tr>
              <tr>
                <td>业主所得收益份额—预扣税前</td>
                <td>1,500,000</td>
              </tr>
            </tbody>
          </table>
          <small>
            <em>
              注意：租赁计划的运作由管理方自行决定，并可能有所变更。以上例子仅说明如何确定租金回报，并不代表实际获得的回报{" "}
            </em>
          </small>
        </div>
      )
    }
  },
  {
    categoryId: 3,
    question: "How is my rental return paid?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Owners will be paid rental returns direct to
            their nominated bank on a quarterly basis.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Владельцы будут получать доходы от сдачи в
            аренду посредством ежеквартального прямого перечисления денежных
            средств на указанный ими банковский счет.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong> 租金回报将按季度直接转账至业主指定的银行账户。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 3,
    question:
      "What are the taxes levied on the rental program that an owner will be subject to?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Rental distributions made to non-resident
            (foreign) owners are subject to 15% withholding tax. Rental earned
            by Thai tax residents are subject to 5% withholding tax.
          </p>
          <small>
            <em>
              Note: applicable tax rates are current at the date of issue of
              this FAQ and may be subject to changes. The villa owner shall be
              responsible for any income and any other taxes, duties and fees of
              whatever nature which may be levied by relevant authorities on the
              villa in connection with the rental.
            </em>
          </small>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Доход с аренды, получаемый собственниками, не
            проживающими в стране на постоянной основе (иностранные граждане),
            облагается налогом в размере 15%. Доход с аренды, получаемый
            собственниками, проживающими в стране на постоянной основе,
            облагается налогом в размере 5%.
          </p>
          <small>
            <em>
              Примечание: указанные налоговые ставки действуют на момент
              публикации данного документа и могут быть подвержены изменениям.
              Владельцы вилл несут ответственность за получаемые доходы и уплату
              разнообразных налогов, пошлин и сборов, которые могут взиматься
              соответствующими государственными органами в связи со сдачей
              собственности в аренду.
            </em>
          </small>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong> 向非居民(外籍) 业主发放租金，需缴纳15%
            的预扣税。泰国纳税居民获得的租金需缴纳5% 的预扣税。
          </p>
          <br />
          <p>
            <em>
              注意：此税收率仅以常见问题解答（FAQ）发布日的相关泰国税务法为标准，若更改请遵循。别墅业主应负责支付有关当局可能对别墅征收的任何所得税和任何其他性质的税款、关税和费用。
            </em>
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 3,
    question: "Can I rent my villa out on my own?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> No. All rentals must be conducted exclusively
            through the manager.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Нет. Сдача в аренду осуществляется исключительно
            через управляющую компанию
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong> 不可以。所有租赁事务必须由管理方专门处理。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 3,
    question: "Can I choose my own furniture?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            A standard hotel furniture package will be required for all villas.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>Для всех вилл требуется стандартный комплект мебели.</p>
        </div>
      ),
      cn: (
        <div>
          <p>我可以选择自己的家具吗？</p>
        </div>
      )
    }
  },
  {
    categoryId: 3,
    question: "Can I stay at any time?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> This is subject to the terms and conditions
            imposed under the rental option selected (eg blackout dates shall
            apply during peak demand periods where a guaranteed rental is
            payable). All reservations by owners for their stays are subject to
            availability.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Это зависит от условий выбранного варианта
            аренды (например, в случае выбора гарантированного возврата дохода с
            аренды, пребывание может быть невозможно в течение периодов
            повышенного спроса). Бронирование владельцами зависит от наличия
            свободных дат.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            这受所选租赁方案规定的条款和条件的约束（例如，在支付固定租金期间的高峰期，可能有不接受入住的日期）。所有业主预订均需视酒店客房率情况而定。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 3,
    question: "How much advance notice is required for my stay?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Owners should provide as much notice as possible
            as villas may be pre-booked with third party guests, particularly
            for stays during high season periods.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Владельцам необходимо сообщать о своем
            пребывании как можно раньше, так как апартаменты могут быть
            забронированы другими гостями, особенно в высокий сезон.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            业主应尽早发出通知，因为第三方客户可能会提前预订入住公寓，旺季尤其如此。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 3,
    question: "Can my friends use my owner’s entitlement?",
    displayOn: ["en", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Yes, subject to terms and conditions of the
            rental agreement (e.g. owners’ guests may be required to be
            pre-registered with the manager).
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            是的，受租赁协议的条款和条件约束（例如，业主的客人可能需要在管理方预先登记）。
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 3,
    question: "What utilities do I have to pay?",
    displayOn: ["en", "cn", "ru"],
    answer: {
      en: (
        <div>
          <p>
            These costs will be covered by the revenue share retained by the
            manager.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Эти расходы будут покрываться за счет доли доходов, причитающейся
            управляющей компании.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>这些费用将由管理方留存的收入份额支付。</p>
        </div>
      )
    }
  },
  {
    categoryId: 4,
    question:
      "What types of property management services are offered and what is the approximate cost?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            <strong>A.</strong> Dusit Laguna Phuket will provide a full range of
            services (including housekeeping, pool cleaning, pest control,
            routine and preventative maintenance, etc) and these are included as
            part of the rental program.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            <strong>O.</strong> Dusit Laguna Phuket предоставляет полный спектр
            услуг (в том числе уборку вилл, чистку бассейна, уничтожение
            вредителей, плановые и профилактические работы и т. д.). Это
            является частью арендной программы.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            <strong>答.</strong>{" "}
            普吉岛乐古浪都喜酒店提供全方位的服务（包括家政服务、泳池清洁、虫害防治、日常维护和预防性维护等），这些都包含在租赁计划中。{" "}
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 5,
    question:
      "What privileges will I receive as an owner of a Laguna Phuket property?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            Owners will receive membership to the exclusive ‘Sanctuary Club’
            which entitles owners to discounts and privileges at Banyan Tree,
            Angsana, Cassia, Dhawa and Laguna resorts, spas and galleries
            worldwide including:
          </p>
          <ul>
            <li>
              30% discount on best available rates for hotel accommodation
            </li>
            <li>25% discount on food and beverage</li>
            <li>30% discount on golf green fees</li>
            <li>20% discount on a-la-carte spa menu</li>
            <li>15% discount on gallery merchandise</li>
            <li>15% discount on in-house tours</li>
            <li>15% discount on laundry</li>
            <li>10% discount airport and ferry terminal transfers</li>
            <li>Priority wait-list on reservations</li>
            <li>Early check-in / late check-out</li>
          </ul>
          <p>
            Owners participating in the rental program, deposit 15 days of the
            annual use entitlement to exchange for free stays at participating
            properties within the global network.
          </p>
          <p>Terms and conditions apply.</p>
        </div>
      ),
      ru: (
        <div>
          <p>
            Собственники недвижимости становятся участниками эксклюзивного клуба
            Banyan Tree Sanctuary Club, что дает им право на скидки и привилегии
            на всех курортах, в спа-центрах и торговых галереях Banyan Tree,
            Angsana, Cassia, Dhawa и Laguna по всему миру, в том числе:
          </p>
          <ul>
            <li>
              Скидка 30 % на самые низкие доступные цены на проживание в отелях
            </li>
            <li>Скидка 25 % на еду и напитки</li>
            <li>Скидка 30 % на пользование полем для гольфа</li>
            <li>Скидка 20 % на спа-процедуры</li>
            <li>Скидка 15 % на покупки в торговых галереях</li>
            <li>Скидка 15 % на организуемые компанией экскурсий</li>
            <li>Скидка 15 % на услуги прачечной</li>
            <li>
              Скидка 10 % на трансфер от/до аэропорта и паромного терминала
            </li>
            <li>Приоритет в списке ожидания при бронировании</li>
            <li>Ранний заезд/поздний выезд</li>
          </ul>
          <p>
            Владельцы, участвующие в программе сдачи в аренду, могут обменять 15
            дней своего ежегодного проживания на бесплатное проживание на
            курортах глобальной сети, участвующих в программе.
          </p>
          <p>Применяются действующие условия.</p>
        </div>
      ),
      cn: (
        <div>
          <p>
            答. 业主将获得独家的“榕源会”
            会员资格，该俱乐部允许业主在全球各地的悦榕庄、悦椿、悦梿、悦苑及乐古浪度假村品牌旗下的度假村、水疗中心和艺品阁享受特权和折扣，其中包括：
          </p>
          <ul>
            <li>酒店住宿最优价格7折</li>
            <li>餐饮7.5折</li>
            <li>高尔夫场地费7折</li>
            <li>水疗中心按摩方式随心选8折</li>
            <li>零售艺品店商品8.5折</li>
            <li>酒店提供旅行8.5折</li>
            <li>洗衣服务8.5折</li>
            <li>机场及渡船码头接送9折</li>
            <li>优先预订</li>
            <li>提早入住/延迟退房</li>
          </ul>
          <p>
            参与租赁计划的业主，可以用自己名下房产每年免费使用天数中的15
            天，交换悦榕全球网络内其他参与物业的免费住宿。{" "}
          </p>
          <p>
            <em>受条款和条件约束。</em>
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 5,
    question: "Will the property come with a golf membership?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>
            A regular golf membership is included with the property. This is
            transferrable upon resale of the property.
          </p>
        </div>
      ),
      ru: (
        <div>
          <p>
            A regular golf membership is included with the property. This is
            transferrable upon resale of the property.
          </p>
        </div>
      ),
      cn: (
        <div>
          <p>
            答.
            业主可获得普吉岛乐古浪高尔夫俱乐部的普通高尔夫会员资格。会籍会随着房产的转让而转让
          </p>
        </div>
      )
    }
  },
  {
    categoryId: 7,
    question: "What are the terms of payment?",
    displayOn: ["en", "ru", "cn"],
    answer: {
      en: (
        <div>
          <p>There are 2 options available:</p>
          <p>
            <strong>
              Option 1: 100% Payment upon purchase / during construction
            </strong>
            <br />
            100% payment upon purchase for already completed properties.
            Progressive payments for properties under construction are as per
            the table below.
          </p>
          <table>
            <thead>
              <tr>
                <th>Construction Payment Term</th>
                <th className="th-col2">Of Selling Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>st</sup> Payment upon signing contact
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>nd</sup> Payment when construction is 25% complete
                  <sup>1</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  3<sup>rd</sup> Payment when construction is 50% complete
                  <sup>2</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  4<sup>th</sup> Payment when construction is 75% complete
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  5<sup>th</sup> Payment upon completion of construction
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>Total</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>Concrete structure substantially completed</small>
            </li>
            <li>
              <small>
                Roof, brickwork and rendering substantially completed
              </small>
            </li>
            <li>
              <small>
                Electrical conduits, and pipe work and plastering substantially
                completed
              </small>
            </li>
          </ol>
          <p>
            <strong>
              Option 2: 50% payment upon purchase / during construction with 50%
              deferred payment over 1, 3 or 5 years
            </strong>
            <br />
            50% payment upon purchase for already completed properties.
            Progressive payments for properties under construction (50% during
            construction / 50% post construction) as per the table below.
          </p>

          <table>
            <thead>
              <tr>
                <th>Deferred Payment Plan</th>
                <th className="th-col2">Of Selling Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  1<sup>st</sup> Payment upon signing contract
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2<sup>nd</sup> Payment when construction is 50% complete
                  <sup>1</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  3<sup>rd</sup> Payment when construction is 75% complete
                  <sup>2</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  4<sup>th</sup> Payment upon completion of construction
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  Post construction payments
                  <sup>4</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>Financing Options</th>
                <th className="th-col2">
                  Interest Rate
                  <br />
                  (per annum)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 Year (12 monthly installments)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 Year (36 monthly installments)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 Year (60 monthly installments)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>Concrete structure substantially completed</small>
            </li>
            <li>
              <small>
                Roof, brickwork and rendering substantially completed
              </small>
            </li>
            <li>
              <small>
                Electrical conduits and pipe work substantially completed
              </small>
            </li>
            <li>
              <small>See table below</small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>Price</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Reservation Deposit</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Construction Completion <br />
                    Payment 50% (Minus Deposit)
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Remaining Post Finance 50%</strong>
                </td>
                <td colSpan="3" className="td-group-title">
                  <strong>Monthly Installment</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 Year (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 Year (5%)</strong>
                </td>
                <td>
                  <strong>5 Year (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>45,000,000</td>
                <td>100,000</td>
                <td>22,400,000</td>
                <td>22,500,000</td>
                <td>1,905,608</td>
                <td>674,345</td>
                <td>445,527</td>
              </tr>
              <tr>
                <td>50,000,000</td>
                <td>100,000</td>
                <td>24,900,000</td>
                <td>25,000,000</td>
                <td>2,117,342</td>
                <td>749,272</td>
                <td>495,030</td>
              </tr>
              <tr>
                <td>55,000,000</td>
                <td>100,000</td>
                <td>27,400,000</td>
                <td>27,500,000</td>
                <td>2,329,077</td>
                <td>824,200</td>
                <td>544,533</td>
              </tr>
            </tbody>
          </table>
          <small>Notes:</small>
          <ol className="notes">
            <li>
              <small>All amounts are stated in Thai Baht (THB).</small>
            </li>
            <li>
              <small>
                The above table sets out the estimated payments required under
                the respective payment plans for selling prices between THB
                45,000,000 – 55,000,000.
              </small>
            </li>
            <li>
              <small>
                The estimated payments are indicative only and the developer /
                seller does not accept any responsibility or liability
                whatsoever for any inaccuracies or omissions.
              </small>
            </li>
            <li>
              <small>Payment terms are subject to change without notice.</small>
            </li>
          </ol>
          <br />
          <p class="pull-right">Updated: 19 April 2019</p>
        </div>
      ),
      ru: (
        <div>
          <p>Предусмотрено 2 варианта:</p>
          <p>
            <strong>
              Вариант 1: 100% оплата при покупке/во время строительства
            </strong>
            <br />
            100% оплата при покупке уже сданной в эксплуатацию недвижимости.
            Прогрессивные платежи для строящихся объектов, согласно таблице
            ниже.
          </p>
          <table>
            <thead>
              <tr>
                <th>Сроки платежей во время строительства</th>
                <th className="th-col2">От цены продажи</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1-ый платеж: при подписании контракта</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2-ой платеж: при выполнении проекта застройки на 25%
                  <sup>1</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  3-ий платеж: при выполнении проекта застройки на 50%
                  <sup>2</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  4-ый платеж: при выполнении проекта застройки на 75%
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>5-ый платеж: по завершении строительства</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>Всего</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>Примечания:</small>
          <ol className="notes">
            <li>
              <small>
                Практически завершено возведение бетонных конструкций
              </small>
            </li>
            <li>
              <small>
                Завершено строительство крыши, кирпичная кладка и облицовка
                здания в целом
              </small>
            </li>
            <li>
              <small>
                Практически завершена прокладка электросетей, прокладка
                трубопроводов и штукатурные работы
              </small>
            </li>
          </ol>
          <p>
            <strong>
              Вариант 2: 50% оплата при покупке/во время строительства с 50%
              рассрочкой платежа на 1, 3 или 5 лет
            </strong>
            <br />
            50% оплата при покупке уже завершенной недвижимости. Постепенная
            оплата строящихся объектов (50% во время строительства/50% по
            завершении строительства), согласно приведенной ниже таблице.
          </p>
          <table>
            <thead>
              <tr>
                <th>План рассрочки платежей</th>
                <th className="th-col2">От цены продажи</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1-ый платеж: при подписании контракта</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  2-ой платеж: при выполнении проекта застройки на 50%
                  <sup>1</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  3-ий платеж: при выполнении проекта застройки на 75%
                  <sup>2</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  4-ый платеж: по завершении строительства3
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  Платежи по завершении строительства4
                  <sup>4</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>Варианты финансирования</th>
                <th className="th-col2">
                  Процентная ставка
                  <br />
                  (годовые)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 год (12 ежемесячных выплат)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 год (36 ежемесячных выплат)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 лет (60 ежемесячных выплат)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>Примечания:</small>
          <ol className="notes">
            <li>
              <small>
                Практически завершено возведение бетонных конструкций
              </small>
            </li>
            <li>
              <small>
                Завершено строительство крыши, кирпичная кладка и облицовка
                здания в целом
              </small>
            </li>
            <li>
              <small>
                Практически завершена прокладка электросетей, прокладка
                трубопроводов и штукатурные работы
              </small>
            </li>
            <li>
              <small>См. таблицу ниже</small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>Цена</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Резервационный депозит</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    Платеж по окончании строительства - 50%
                    <br />
                    (с вычетом депозита)
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>Оставшаяся сумма платежа - 50%</strong>
                </td>
                <td colSpan="3" className="td-group-title">
                  <strong>Ежемесячные взносы</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1 год (3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3 года (5%)</strong>
                </td>
                <td>
                  <strong>5 года (7%)</strong>
                </td>
              </tr>
              <tr>
                <td>45,000,000</td>
                <td>100,000</td>
                <td>22,400,000</td>
                <td>22,500,000</td>
                <td>1,905,608</td>
                <td>674,345</td>
                <td>445,527</td>
              </tr>
              <tr>
                <td>50,000,000</td>
                <td>100,000</td>
                <td>24,900,000</td>
                <td>25,000,000</td>
                <td>2,117,342</td>
                <td>749,272</td>
                <td>495,030</td>
              </tr>
              <tr>
                <td>55,000,000</td>
                <td>100,000</td>
                <td>27,400,000</td>
                <td>27,500,000</td>
                <td>2,329,077</td>
                <td>824,200</td>
                <td>544,533</td>
              </tr>
            </tbody>
          </table>
          <small>Примечания:</small>
          <ol className="notes">
            <li>
              <small>
                Практически завершено возведение бетонных конструкций
              </small>
            </li>
            <li>
              <small>
                Завершено строительство крыши, кирпичная кладка и облицовка
                здания в целом
              </small>
            </li>
            <li>
              <small>
                Практически завершена прокладка электросетей, прокладка
                трубопроводов и штукатурные работы
              </small>
            </li>
            <li>
              <small>См. таблицу ниже</small>
            </li>
          </ol>
          <br />
          <p class="pull-right">Последняя версия: 19 апрель 2019</p>
        </div>
      ),
      cn: (
        <div>
          <p>答. 我们提供两种付款方案供选择：</p>
          <p>
            <strong>方案1: 购买时刻/施工期间付款100%</strong>
            <br />
            对于已建成房产，依据购买价格100%付款。对于在建房产，依据下表按进度分期付款。
          </p>
          <table>
            <thead>
              <tr>
                <th>施工付款条款</th>
                <th className="th-col2">占销售价格</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>签订合同时第1笔付款</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  施工完成25％时第2笔付款
                  <sup>1</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  施工完成50％时第3笔付款
                  <sup>2</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  施工完成75％时第4笔付款
                  <sup>3</sup>
                </td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>>施工完成时第5笔付款</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>总计</td>
                <td className="td-col2">100%</td>
              </tr>
            </tbody>
          </table>
          <small>注意：</small>
          <ol className="notes">
            <li>
              <small>
                <em>混凝土结构基本完工</em>
              </small>
            </li>
            <li>
              <small>
                <em>屋顶、砖砌和粉刷工程基本完工</em>
              </small>
            </li>
            <li>
              <small>
                <em>电缆、管道和泥水工程基本完工</em>
              </small>
            </li>
          </ol>
          <p>
            <strong>
              方案2: 购买时刻/施工期间付款50%，剩余50%分1年，3年或5年延期付款
            </strong>
            <br />
            对于已建成房产，依据购买价格50%付款。对于在建房产(施工期间付款50%，剩余50%施工完成以后付款)
            依据下表按进度分期付款。{" "}
          </p>

          <table>
            <thead>
              <tr>
                <th>延期付款计划</th>
                <th className="th-col2">占销售价格</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>签订合同时第1笔付款</td>
                <td className="td-col2">20%</td>
              </tr>
              <tr>
                <td>
                  施工完成50％时第2笔付款
                  <sup>1</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  施工完成75％时第3笔付款
                  <sup>2</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  施工完成时第4笔付款
                  <sup>3</sup>
                </td>
                <td className="td-col2">10%</td>
              </tr>
              <tr>
                <td>
                  施工完成以后付款
                  <sup>4</sup>
                </td>
                <td className="td-col2">50%</td>
              </tr>
            </tbody>
          </table>

          <table>
            <thead>
              <tr>
                <th>付款方案</th>
                <th className="th-col2">
                  利率
                  <br />
                  (每年)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 年(12 个月分期付款)</td>
                <td className="td-col2">3%</td>
              </tr>
              <tr>
                <td>3 年(36 个月分期付款)</td>
                <td className="td-col2">5%</td>
              </tr>
              <tr>
                <td>5 年(60 个月分期付款)</td>
                <td className="td-col2">7%</td>
              </tr>
            </tbody>
          </table>
          <small>
            <em>注意：</em>
          </small>
          <ol className="notes">
            <li>
              <small>
                <em>混凝土结构基本完工</em>
              </small>
            </li>
            <li>
              <small>
                <em>屋顶、砖砌和粉刷工程基本完工</em>
              </small>
            </li>
            <li>
              <small>
                <em>电缆、管道和泥水工程基本完工</em>
              </small>
            </li>
            <li>
              <small>
                <em>参见下表</em>
              </small>
            </li>
          </ol>

          <table className="table-center">
            <tbody>
              <tr className="tr-title">
                <td rowSpan="2" className="td-title">
                  <strong>价格</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>定金</strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>
                    施工结束后支付50% <br />
                    (扣除定金)
                  </strong>
                </td>
                <td rowSpan="2" className="td-title">
                  <strong>剩余待还款项50%</strong>
                </td>
                <td colSpan="3" className="td-group-title">
                  <strong>每月分期付款</strong>
                </td>
              </tr>
              <tr className="tr-title">
                <td className="td-title">
                  <strong>1年(3%)</strong>
                </td>
                <td className="td-title">
                  <strong>3年(5%)</strong>
                </td>
                <td>
                  <strong>5年(7%)</strong>
                </td>
              </tr>
              <tr>
                <td>45,000,000</td>
                <td>100,000</td>
                <td>22,400,000</td>
                <td>22,500,000</td>
                <td>1,905,608</td>
                <td>674,345</td>
                <td>445,527</td>
              </tr>
              <tr>
                <td>50,000,000</td>
                <td>100,000</td>
                <td>24,900,000</td>
                <td>25,000,000</td>
                <td>2,117,342</td>
                <td>749,272</td>
                <td>495,030</td>
              </tr>
              <tr>
                <td>55,000,000</td>
                <td>100,000</td>
                <td>27,400,000</td>
                <td>27,500,000</td>
                <td>2,329,077</td>
                <td>824,200</td>
                <td>544,533</td>
              </tr>
            </tbody>
          </table>
          <small>注意：</small>
          <ol className="notes">
            <li>
              <small>
                <em>所有金额均以泰铢(THB) 表示。</em>
              </small>
            </li>
            <li>
              <small>
                <em>
                  上表列出了当售价为45,000,000 至55,000,000
                  泰铢时，各个付款方案的估计付款额
                </em>
              </small>
            </li>
            <li>
              <small>
                <em>
                  估计付款额仅供参考，开发商/出卖方不承担任何不准确或遗漏的任何责任或法律责任。
                </em>
              </small>
            </li>
            <li>
              <small>
                <em>付款条款如有更改，恕不另行通知。</em>
              </small>
            </li>
          </ol>
          <br />
          <p class="pull-right">更新于：21 December 2018</p>
        </div>
      )
    }
  }
];

export { category, faqs };



// WEBPACK FOOTER //
// ./src/data/PhuketDusitDeluxePoolVilla/faq.js